import { Suspense, useState } from 'react'
import routes from '@routes'
import { createBrowserRouter, createRoutesFromChildren, Navigate, Route, RouterProvider } from 'react-router-dom'
import { debugRouteFailure, renderRoute, showErrorForRouteFailures } from '@/app/App.lib'
import { useQuery } from '@tanstack/react-query'
import * as actions from '@actions/user'
import { ROLE_ANNOTATOR_USER, ROLE_CHECK_MANAGER } from '@constants'
import CircleSpinner from '@components/shared/CircleSpinner'

const AppWithDataRouter = () => {
    
    const [redirectUrl, setRedirectUrl] = useState(null)
    
    const {
        error: userError,
        isLoading: userIsLoading,
    } = useQuery({
        queryKey: ['AppWithDataRouter#user'],
        queryFn: async () => {
            
            let res = null
            
            try {
                
                res = await actions.fetchProfile()
                
                const token = localStorage.getItem('jwt')
                const isAnnotator = res?.roles?.some(it => it.name === ROLE_ANNOTATOR_USER) || false
                const isCheckManager = res?.roles?.some(it => [ROLE_CHECK_MANAGER].includes(it.name))
                const isOnlyCheckManager = isCheckManager && res?.roles?.length === 1
                
                setRedirectUrl(token?.length > 0
                    ? isAnnotator
                        ? '/partners'
                        : isOnlyCheckManager ? '/checks' : '/collections'
                    : '/signin')
                
            } catch (e) {
                console.error('AppWithUser#query failed to fetch user profile', e)
            }
            
            return res
            
        },
        enabled: !redirectUrl,
        retry: 0,
    })
    
    const router = createBrowserRouter(
        createRoutesFromChildren([...routes.map(renderRoute), showErrorForRouteFailures
            ? debugRouteFailure
            : <Route path="*" element={<Navigate to={redirectUrl} />} />]),
    )
    
    if (userError) return (
        <div className="absolute inset-0 flex flex-col justify-center">
            <p>An unknown error occurred when fetching your profile.</p>
            <p>Please try again.</p>
        </div>
    )
    
    if (userIsLoading || !redirectUrl?.length) return (
        <div className="absolute inset-0 flex flex-col justify-center">
            <span className="loading loading-spinner" />
        </div>
    )
    
    return (
        <Suspense fallback={<CircleSpinner className="absolute-centered" />}>
            <RouterProvider router={router} fallbackElement={<CircleSpinner className="absolute-centered" />} />
        </Suspense>
    )
    
}

export default AppWithDataRouter
